import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import ApexCharts from "apexcharts";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { FaDownload } from "react-icons/fa";
import DashboardLayout from "../DashboardLayout";
import ReactApexChart from "react-apexcharts";
import { useNavigate } from "react-router-dom";
import {
  getDonationsStatsDataReport,
  getGamesStatsDataReport,
  getPastWeekDonationsReport,
  getQuarterlyRevenueReport,
  getRegisteredGamesReport,
  getRevenueStatsDataReport,
  getToppersReportDataReport,
  getTotalTraficReport,
  getUserStatsDataReport,
  getAdVIewCompletionDataReport,
  getAdViewPerGameDataReport,
} from "./helperMethods";
import DonationChart from "./donationChart";
import TotalTrafficChart from "./totalTraficChart";
import RegisteredGamesChart from "./registerGamesChart";
import RevenueChart from "./revenueChart";
import ToppersReport from "./toppersReport";
import AdViewCompletionChart from "./adViewCompletionChart";
import AdViewsPerGameChart from "./adViewsPerGameChart";
import HeaderCharts from "./headerCharts";
import LoadingSpinner from "../../Components/spinner";
import { exportToPDF } from "./exportPDF";
import { useAppContext } from "../../services/context";
import { exportToExcel } from "./exportExcel";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

function Report() {
  const navigation = useNavigate();
  const { state } = useAppContext();
  const { permissions } = state;
  // // // For Header Charts
  const [fetching, setFetching] = useState(true);
  const [UserStatsDataReport, setUserStatsDataReport] = useState({});
  const [RevenueStatsDataReport, setRevenueStatsDataReport] = useState({});
  const [DonationsStatsDataReport, setDonationsStatsDataReport] = useState({});
  const [GamesStatsDataReport, setGamesStatsDataReport] = useState({});
  // // // For Main Charts
  const [registeredGames, setRegisteredGames] = useState([]);
  const [totalTrafic, setTotalTrafic] = useState([]);
  const [quarterlyRevenue, setQuarterlyRevenue] = useState([]);
  const [pastWeekDonations, setPastWeekDonations] = useState([]);
  const [toppersReportData, setToppersReportData] = useState({});
  const [adViewCompletionData, setAdViewCompletionData] = useState([]);
  const [adViewPerGameData, setAdViewPerGameData] = useState([]);
  const [granted, setGranted] = useState([]);

  const extractPermissions = () => {
    const perms = permissions.filter((f) => f.module === "Reports");
    if (perms) {
      setGranted(perms);
    }
  };

  const fetchAllReportsData = async () => {
    await getUserStatsDataReport(setUserStatsDataReport, navigation);
    await getRevenueStatsDataReport(setRevenueStatsDataReport, navigation);
    await getDonationsStatsDataReport(setDonationsStatsDataReport, navigation);
    await getGamesStatsDataReport(setGamesStatsDataReport, navigation);
    await getRegisteredGamesReport(setRegisteredGames, navigation);
    await getTotalTraficReport(setTotalTrafic, navigation);
    await getQuarterlyRevenueReport(setQuarterlyRevenue, navigation);
    await getPastWeekDonationsReport(setPastWeekDonations, navigation);
    await getToppersReportDataReport(setToppersReportData, navigation);
    await getAdVIewCompletionDataReport(setAdViewCompletionData, navigation);
    await getAdViewPerGameDataReport(setAdViewPerGameData, navigation);
    setFetching(false);
  };

  useEffect(() => {
    extractPermissions();
    fetchAllReportsData();
  }, []);

  return (
    <DashboardLayout>
      {fetching ? (
        <div className="container-fluid">
          <div className="d-flex justify-center">
            <LoadingSpinner size={"large"} />
          </div>
        </div>
      ) : (
        <div className="main mt-3" data-testid="reports">
          <HeaderCharts
            UserStatsDataReport={UserStatsDataReport}
            RevenueStatsDataReport={RevenueStatsDataReport}
            DonationsStatsDataReport={DonationsStatsDataReport}
            GamesStatsDataReport={GamesStatsDataReport}
          />
          <div className="d-flex flex-column flex-md-row justify-content-end align-items-end mb-3">
            <div className="d-flex gap-2 mt-3 mt-md-0 align-items-end">
              {granted?.some((g) => g.type === "download-excel") && (
                <button
                  className="btn btn-success d-flex align-items-center gap-2 btn-sm fw-bold px-3"
                  onClick={() => {
                    exportToExcel(
                      granted,
                      registeredGames,
                      totalTrafic,
                      quarterlyRevenue,
                      pastWeekDonations,
                      toppersReportData,
                      adViewCompletionData,
                      adViewPerGameData
                    );
                  }}
                >
                  <FaDownload /> Export to Excel
                </button>
              )}
              {granted?.some((g) => g?.type === "download-pdf") && (
                <button
                  className="btn btn-primary d-flex align-items-center gap-2 btn-sm fw-bold px-3"
                  onClick={() => {
                    exportToPDF(
                      granted,
                      registeredGames,
                      totalTrafic,
                      quarterlyRevenue,
                      pastWeekDonations,
                      toppersReportData,
                      adViewCompletionData,
                      adViewPerGameData
                    );
                  }}
                >
                  <FaDownload /> Export to PDF
                </button>
              )}
            </div>
          </div>
          <div className="row mt-4">
            <DonationChart pastWeekDonations={pastWeekDonations} />
            <TotalTrafficChart totalTrafic={totalTrafic} />
          </div>
          <div className="row g-3 align-items-stretch mt-3">
            <RegisteredGamesChart registeredGames={registeredGames} />
            <RevenueChart quarterlyRevenue={quarterlyRevenue} />
            <ToppersReport toppersReportData={toppersReportData} />
          </div>

          <div className="row g-3 align-items-stretch mt-3">
            <div className="col-md-6 col-sm-12">
              <AdViewCompletionChart
                adViewCompletionData={adViewCompletionData}
              />
            </div>
            <div className="col-md-6 col-sm-12">
              <AdViewsPerGameChart adViewPerGameData={adViewPerGameData} />
            </div>
          </div>
        </div>
      )}
      <style>
        {`
                .card {
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                }

                .card:hover {
                    transform: translateY(-5px);
                box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
                     }

                .bg-gradient-primary {
                    background: linear-gradient(90deg, #007bff, #0056b3);
                        }

                .bg-gradient-success {
                    background: linear-gradient(90deg, #28a745, #1e7e34);
                }

                .bg-gradient-warning {
                    background: linear-gradient(90deg, #ffc107, #e0a800);
                }

                .bg-gradient-info {
                    background: linear-gradient(90deg, #17a2b8, #117a8b);
                }
                .cardBox{
                   background: #2B2D3E
                }

                 .table-striped tbody tr:nth-of-type(odd) {
                    background-color: #1e1e2f !important;
                  }

                .table-hover tbody tr:hover {
                    background-color: #343a40 !important;
                }

                    th {
                    font-size: 0.9rem;
                    letter-spacing: 1px;
                    }

                    .badge {
                        padding: 0.4em 0.6em;
                        font-size: 0.8rem;
                        border-radius: 0.5rem;
                    }

                    td, th {
                        vertical-align: middle;
                    }

                    a {
                        transition: color 0.3s ease;
                    }

                    a:hover {
                        color: #00d1ff;
                    }
                        .form-select {
                        border-radius: 5px;
                        padding: 0.3rem 0.5rem;
                        font-size: 0.85rem;
                    }
                    .form-select:focus {
                        border-color: #00d1ff;
                        box-shadow: none;
                    } 
                    @media (max-width: 576px) {
                    .row {
                    gap: 16px;
                    }
                    }        
                    
                    /* Ensure WorldMap doesn't overflow the card */
                  .worldmap__figure-container {
                    width: 100%;
                    height: 100%;
                    max-height: 250px; /* or any suitable height */
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    overflow: hidden;
                    background-color: transparent !important;
                  }

                  .worldmap__figure-container svg {
                    max-width: 100%;
                    height: auto;
                    object-fit: contain;
                    background-color: transparent !important;
                  }

        `}
      </style>
    </DashboardLayout>
  );
}

export default Report;
